import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Perfil/updatePerfil`, method: 'POST', body: values, token: token})
}
